import { Fragment } from "react";
import PropTypes from "prop-types";
import { BackButton } from "app/pages/.shared/BackButton/BackButton";
import ShopSwitcherContainer from "app/pages/Home/ShopSwitcher/ShopSwitcherContainer";
import ShopSwitcher from "app/pages/Home/ShopSwitcher/ShopSwitcher";
import "./FaqFooter.scss";
import FaqContactContainer from "app/pages/Faq/FaqFooter/FaqContact/FaqContactContainer";

const FaqFooter = ({ hideContactByPhone, fallbackRedirectUrl }) => {
	return (
		<Fragment>
			<div className="faq-footer__contact">
				<FaqContactContainer hideContactByPhone={hideContactByPhone} />
			</div>
			<footer className="faq-footer">
				<div className="faq-footer__container">
					<div className="faq-footer__back">
						<BackButton
							label={"faq.footer.back.to.label"}
							to={{
								pathname: fallbackRedirectUrl,
							}}
						/>
					</div>
					<div className="faq-footer__shop">
						<ShopSwitcherContainer
							shouldGetAllShops={true}
							renderComponent={props => <ShopSwitcher {...props} />}
						/>
					</div>
				</div>
			</footer>
		</Fragment>
	);
};

FaqFooter.propTypes = {
	hideContactByPhone: PropTypes.bool,
	fallbackRedirectUrl: PropTypes.string,
};

export default FaqFooter;
